import { render, staticRenderFns } from "./IconDocumentNotes.vue?vue&type=template&id=4e9c4a1c&functional=true&"
import script from "./IconDocumentNotes.vue?vue&type=script&lang=js&"
export * from "./IconDocumentNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports